const firebaseConfig = {
  apiKey: "AIzaSyD_vqzc2b3Llh8x16zOdirszu1AWi5NPNc",
  authDomain: "ayeshbd-7fc41.firebaseapp.com",
  projectId: "ayeshbd-7fc41",
  storageBucket: "ayeshbd-7fc41.appspot.com",
  messagingSenderId: "386696506857",
  appId: "1:386696506857:web:3f27ee8c05588c1415ef78",
};
export default firebaseConfig;
